/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { CanvasGridCellBase } from "./CanvasGridCellBase";
import { markType } from "igniteui-react-core";
/**
 * @hidden
 */
var CanvasTextCell = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(CanvasTextCell, _super);
    function CanvasTextCell(a) {
        var _this = _super.call(this, a) || this;
        _this.ce(0);
        _this.cm(1);
        return _this;
    }
    CanvasTextCell.prototype.get_aa = function () {
        return true;
    };
    CanvasTextCell.$t = markType(CanvasTextCell, 'CanvasTextCell', CanvasGridCellBase.$);
    return CanvasTextCell;
}(CanvasGridCellBase));
export { CanvasTextCell };
//# sourceMappingURL=CanvasTextCell.js.map
